import { Statistiche } from './statistiche';
import { Giocatori } from './giocatori';

export class Squadre {
    public id: number = null;
    public nome: string = null;
    public abbreviazione: string = null;
    public genitivo: string = null;
    public allenatore: string = null;
    public statisticheMatch: Statistiche = null;
    public formazione: Giocatori[] = null;

    constructor() {
        this.statisticheMatch = new Statistiche();
        this.formazione = new Array<Giocatori>();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/squadre.ts